// extracted by mini-css-extract-plugin
export default {"code":"B_cv"};